<div class="modal-overlay" *ngIf="visible && mapping" (click)="closeModal()">
  <div class="details-modal" (click)="$event.stopPropagation()">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">&times;</button>
    <h3>{{ 'assign.detailsTitle' | t:'Assign Flat Details' }}</h3>
    <div class="details-grid">
      <div class="details-item">
        <span class="label">{{ 'assign.renter' | t:'Renter' }}</span>
        <span class="value">{{ mapping?.renter?.renterName || 'N/A' }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'assign.renterMobile' | t:'Renter Mobile' }}</span>
        <span class="value">{{ mapping?.renter?.renterMobile || 'N/A' }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'assign.flat' | t:'Flat' }}</span>
        <span class="value">{{ mapping?.flat?.flatName || 'N/A' }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'filter.house' | t:'House' }}</span>
        <span class="value">{{ mapping?.flat?.house?.houseName || 'N/A' }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'assign.renterStartDate' | t:'Renter Start Date' }}</span>
        <span class="value">{{ formatDateTime(mapping?.renterStartDate) }}</span>
      </div>
      <div class="details-item" *ngIf="mapping?.renterEndDate">
        <span class="label">{{ 'assign.renterEndDate' | t:'Renter End Date' }}</span>
        <span class="value">{{ formatDateTime(mapping?.renterEndDate) }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'renter.status' | t:'Status' }}</span>
        <span class="value">{{ mapping?.status === 1 ? ('common.active' | t:'Active') : ('common.inactive' | t:'Inactive') }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'assign.advanceAmount' | t:'Advance Amount' }}</span>
        <span class="value">{{ formatAmount(mapping?.advanceAmount) }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'assign.usedAdvance' | t:'Used Advance' }}</span>
        <span class="value">{{ formatAmount(mapping?.usedAdvanceAmount) }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'assign.remainingAdvance' | t:'Remaining Advance' }}</span>
        <span class="value">{{ formatAmount(remainingAdvanceAmount(mapping)) }}</span>
      </div>
      <div class="details-item">
        <span class="label">{{ 'assign.createdOn' | t:'Created On' }}</span>
        <span class="value">{{ formatDateTime(mapping?.createdOn) }}</span>
      </div>
      <div class="details-item details-item-full">
            <span class="label">{{ 'renter.agreementDocuments' | t:'Additional Documents' }}</span>
        <div class="doc-list" *ngIf="(mapping?.attachments?.length || 0) > 0; else noDocs">
          <button
            type="button"
            class="doc-link"
            *ngFor="let attachment of mapping?.attachments"
            (click)="openAttachmentPreview(attachment)"
          >
            {{ attachment?.attachmentFileName || ('Document #' + attachment?.id) }}
          </button>
        </div>
        <ng-template #noDocs>
              <span class="value">{{ 'assign.noDocumentUploaded' | t:'No document uploaded.' }}</span>
        </ng-template>
      </div>
    </div>
    <div class="details-actions">
      <button
        type="button"
        class="panel-item panel-item-primary"
        *ngIf="showAddPayment"
        (click)="triggerAddPayment()"
      >{{ 'assign.processPayment' | t:'Process Payment' }}</button>
      <button type="button" class="panel-item" (click)="closeModal()">{{ 'common.close' | t:'Close' }}</button>
    </div>
  </div>
</div>
